import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
    routes: [
        {
            path: `/aqt`,
            name: '全部',
            component: re => require(['@/components/MN/LayContentAll.vue'], re),

            children: [
                {
                    path: `/aqt`,
                    name: '首页',
                    meta: {
                        title: 'aqt',
                        type: 0,//用于记录用户行为  1书籍 2杂志
                    },
                    component: () => import('../views/Index/MN/AqtIndex.vue'),
                },
                {
                    path: '/SearchIndex',
                    name: '搜索页面',
                    meta: {
                        title: 'SearchIndex',
                        type: 0,//用于记录用户行为
                    },
                    component: () => import('../views/SearchIndex/MN/Index.vue'),
                },
                // {
                //     path: '/SongDetails',
                //     name: '歌详情',
                //     meta: {
                //         title: 'SongDetails',
                //         type: 18,//用于记录用户行为  1书籍 2杂志
                //     },
                //     component: () => import('../views/Song/MN/SongDetails.vue'),
                // },
                // {
                //     path: '/ChildrenSongList',
                //     name: '儿童民歌',
                //     meta: {
                //         title: 'ChildrenSongList',
                //         type: 18,//用于记录用户行为  1书籍 2杂志
                //     },
                //     component: () => import('../views/Song/MN/ChildrenSong/ChildrenSongList.vue'),
                // },
                // {
                //     path: '/VideoFrequencyList',
                //     name: '视频列表',
                //     meta: {
                //         title: 'VideoFrequencyList',
                //         type: 40,//用于记录用户行为  1书籍 2杂志
                //     },
                //     component: () => import('../views/VideoFrequency/MN/VideoFrequencyList.vue'),
                // },
                // {
                //     path: '/VideoFrequencyListDetails',
                //     name: '视频详情',
                //     meta: {
                //         title: 'VideoFrequencyListDetails',
                //         type: 40,//用于记录用户行为  1书籍 2杂志
                //     },
                //     component: () => import('../views/VideoFrequency/MN/VideoFrequencyListDetails.vue'),
                // },
            ]

        },
        {
            path: `/External`,
            name: '全部',
            component: re => require(['@/components/MN/LayContentAll.vue'], re),

            children: [
                {
                    path: `/External`,
                    name: '首页',
                    meta: {
                        title: 'External',
                        type: 0,//用于记录用户行为  1书籍 2杂志
                    },
                    component: () => import('../views/Index/MN/AqtIndex.vue'),
                },
                {
                    path: '/SearchIndex',
                    name: '搜索页面',
                    meta: {
                        title: 'SearchIndex',
                        type: 0,//用于记录用户行为
                    },
                    component: () => import('../views/SearchIndex/MN/Index.vue'),
                },
                // {
                //     path: '/SongDetails',
                //     name: '歌详情',
                //     meta: {
                //         title: 'SongDetails',
                //         type: 18,//用于记录用户行为  1书籍 2杂志
                //     },
                //     component: () => import('../views/Song/MN/SongDetails.vue'),
                // },
                // {
                //     path: '/ChildrenSongList',
                //     name: '儿童民歌',
                //     meta: {
                //         title: 'ChildrenSongList',
                //         type: 18,//用于记录用户行为  1书籍 2杂志
                //     },
                //     component: () => import('../views/Song/MN/ChildrenSong/ChildrenSongList.vue'),
                // },
                // {
                //     path: '/VideoFrequencyList',
                //     name: '视频列表',
                //     meta: {
                //         title: 'VideoFrequencyList',
                //         type: 40,//用于记录用户行为  1书籍 2杂志
                //     },
                //     component: () => import('../views/VideoFrequency/MN/VideoFrequencyList.vue'),
                // },
                // {
                //     path: '/VideoFrequencyListDetails',
                //     name: '视频详情',
                //     meta: {
                //         title: 'VideoFrequencyListDetails',
                //         type: 40,//用于记录用户行为  1书籍 2杂志
                //     },
                //     component: () => import('../views/VideoFrequency/MN/VideoFrequencyListDetails.vue'),
                // },
            ]

        },
        {
            path: `/zhver`,
            name: '全部',
            component: re => require(['@/components/ZH/LayContentAll.vue'], re),

            children: [
                {
                    path: `/zhver`,
                    name: '首页',
                    meta: {
                        title: 'zhver',
                        type: 0,//用于记录用户行为  1书籍 2杂志
                    },
                    component: () => import('../views/Index/ZH/AqtIndex.vue'),
                },
                {
                    path: '/SearchIndexZh',
                    name: '搜索页面',
                    meta: {
                        title: 'SearchIndexZh',
                        type: 0,//用于记录用户行为
                    },
                    component: () => import('../views/SearchIndex/ZH/Index.vue'),
                },

            ]
        },
        {
            path: `/login`,
            name: '登录',
            meta: {
                title: '登录',
                type: 0,//用于记录用户行为  1书籍 2杂志
            },
            component: re => require(['../views/Login.vue'], re),
        }
    ],
    // mode: 'history',
})
